/* eslint-disable max-len */
import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { type EventApplicationEntrypointContextDataFragment } from '../../../../api/fragments/EventApplicationEntrypointContextData';
import {
    type UpdateEventApplicationMutation,
    type UpdateEventApplicationMutationVariables,
    UpdateEventApplicationDocument,
} from '../../../../api/mutations/updateEventApplication';
import { type CustomerKind } from '../../../../api/types';
import { type ApplicantFormValues } from './shared';

const useUpdateEventApplication = (endpoint: EventApplicationEntrypointContextDataFragment) => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: ApplicantFormValues, customerKind: CustomerKind) => {
            const { data } = await apolloClient.mutate<
                UpdateEventApplicationMutation,
                UpdateEventApplicationMutationVariables
            >({
                mutation: UpdateEventApplicationDocument,
                variables: {
                    token,
                    dealerId: values.dealerId,
                    vehicle: {
                        existingSimpleLocalVehicleId: values.vehicleInterest.variant,
                    },
                    configuration: values.configuration,
                    tradeInVehicle: values.tradeInVehicle.filter(({ isSelected }) => isSelected),
                    customerKind,
                    customizedFields: values.customizedFields,
                    remarks: values.remarks,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useUpdateEventApplication;
